import {useContext} from 'react';
import {ScreenZoomContext} from '@shared/core/services/screen-zoom';

import {BookingMeetingRoomForm} from '../booking-meeting-room-form';
import * as Styled from './book-meeting-room-modal.styles';

interface BookMeetingRoomModalProps {
  meetingRoomId: string;
  title: string;
  floorAddress: string;
  onClose: () => void;
  infoModal: (text: JSX.Element, title: string, button: string) => void;
}

const BookMeetingRoomModal = ({meetingRoomId, title, floorAddress, onClose, infoModal}: BookMeetingRoomModalProps) => {
  const {screenZoom} = useContext(ScreenZoomContext);

  return (
    <Styled.Container zoom={screenZoom}>
      <Styled.ModalHeader title={title} onClose={onClose} />
      <Styled.ModalBody>
        <BookingMeetingRoomForm meetingRoomId={meetingRoomId} infoModal={infoModal} floorAddress={floorAddress} />
      </Styled.ModalBody>
    </Styled.Container>
  );
};

export default BookMeetingRoomModal;
